import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable, empty } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { UserService } from './user.service';
import { formatDate } from '@angular/common';
import {
  IAddSampleFinishCategoryBody,
  IErrorList, ISampleFinish, ISampleSubCategory, ISampleSubCategoryRequestGrid1
  , BaseResponse,
  ISampleCategory,
  ISampleRegion,
  ISamplePlaceOrderBody,
  IGetSampleProductOrderHeader,
  ISampleProductOrderHeader,
  ISampleProductOrderDetails,
  IGetSampleProductOrderDetailsByHeader,
  IGetSampleSubCategoryCostBySubcategoryId,
  ISampleSubCategoryCost,
  IGetFilterSampleReorderReport,
  ISampleReorderReport,
  IGetFilterSampleUsageReport,
  ISampleUsageReport,
  ISampleAdminBudget,
  ISampleAdminBudgetAllocation,
  IGetFilterSampleBudgetReport,
  IGetSampleCategoryExternalUser,
  IGetSampleSubCategoryByCategory,
  ISampleSubCategoryExist,
  //ISampleSubCategoryExist,
  
} from '../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductSampleFulfillmentService {
  //#region constructor
  constructor(private httpClient: HttpClient,
    private userService: UserService) { }
  //#endregions
  //#region Api EndPoints

  private SAMPLE_SUB_CATEGORY: Array<ISampleSubCategory> = [];
  public get sampleSubCategory(): Array<ISampleSubCategory> {
    if (!this.SAMPLE_SUB_CATEGORY) {
      this.SAMPLE_SUB_CATEGORY = [];
    }
    return this.SAMPLE_SUB_CATEGORY;
  }
  public set sampleSubCategory(sampleSubCategory: Array<ISampleSubCategory>) {
    this.SAMPLE_SUB_CATEGORY = sampleSubCategory;
  }
  public getSampleSubCategories(): Observable<Array<ISampleSubCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_SUB_CATEGORIES}`;
    // return ApiService.genericObservableGet(this.httpClient, endPoint);
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((sampleSubCategory) => { this.sampleSubCategory = sampleSubCategory }));
  }

  public AddSampleCategory(body: ISampleSubCategory): Observable<Array<ISampleSubCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.ADD_SAMPLE_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((sampleCategory) => this.updateSampleCategoryData(body)));
  }
  public UpdateSampleCategory(body: ISampleSubCategory): Observable<Array<ISampleSubCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.UPDATE_SAMPLE_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((sampleCategory) => this.updateSampleCategoryData(body)));
  }
  public DeleteSampleSubCategory(body: ISampleSubCategory): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.DELETE_SAMPLE__SUB_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
      );
  }
  public AddUpdateSampleSubCategory(body: ISampleSubCategory): Observable<Array<ISampleSubCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.ADD_UPDATE_SAMPLE_SUB_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((sampleFinish) => this.updateSampleCategoryData(body)));
  }

  public GetSampleSubCatgeoryExist(body: ISampleSubCategoryExist): Observable<Array<ISampleSubCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_SUB_CATEGORY_EXIST}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
      );
  }  

  public UpdateInventorySampleSubCategory(body: ISampleSubCategory): Observable<Array<ISampleSubCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.UPDATE_INVENTORY_SAMPLE_SUB_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((sampleFinish) => this.updateSampleCategoryData(body)));
  }

  public updateSampleCategoryData(sampleCategory: ISampleSubCategory) {
    //debugger;
    if (sampleCategory) {
      const indextemp = this.sampleSubCategory.findIndex(r => r.categoryId === sampleCategory.categoryId);
      const temp = this.sampleSubCategory.find(r => r.categoryId === sampleCategory.categoryId);
      if (temp) {
        this.SAMPLE_SUB_CATEGORY.splice(indextemp, 1, sampleCategory);
      } else {
        this.SAMPLE_SUB_CATEGORY.push(sampleCategory);
      }
    }
  }
  
  public getAllSampleSubCategoryCostHistory(body: IGetSampleSubCategoryCostBySubcategoryId): Observable<Array<ISampleSubCategoryCost>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_ALL_SAMPLE_SUBCATEGORY_COST_BY_SUBCATEGORY_ID}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { throw err; }),
      map((items: BaseResponse) => items.data.map((item: ISampleSubCategoryCost) =>
      ({
        subCategoryId: item.subCategoryId,
        subCategoryDescription: item.subCategoryDescription,
        cost: item.cost,
        effectiveFrom: item.effectiveFrom ? new Date(item.effectiveFrom) : null,
        effectiveTo: item.effectiveTo ? new Date(item.effectiveTo) : null,
        isCurrentCost: item.isCurrentCost
      } as ISampleSubCategoryCost))));
  }
  //#region PlaceOrder
  public getActiveSampleCategories(body: IGetSampleCategoryExternalUser): Observable<Array<ISampleCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_ACTIVE_SAMPLE_CATEGORIES}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getActiveSampleSubCategoriesByCatgeory(body: IGetSampleSubCategoryByCategory): Observable<Array<ISampleSubCategoryRequestGrid1>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_ACTIVE_SAMPLE_SUB_CATEGORIES_BY_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public GetSampleRegions(): Observable<Array<ISampleRegion>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_REGIONS}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public placeOrderSampleRequest(body: ISamplePlaceOrderBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.PLACE_ORDER_SAMPLE_REQUEST}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  
  public getSampleProductOrderHeader(body: IGetSampleProductOrderHeader): Observable<Array<ISampleProductOrderHeader>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_PRODUCT_ORDER_HEADER}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { throw err; }),
      map((items: BaseResponse) => items.data.map((item: ISampleProductOrderHeader) =>
      ({
        id: item.id,
        sampleProductRequestHeaderId: item.sampleProductRequestHeaderId,
        firstName: item.firstName,
        lastName: item.lastName,
        customerNumber: item.customerNumber,
        companyName: item.companyName,
        ccEmail: item.ccEmail,
        region: item.region,
        createdDate: item.createdDate ? new Date(item.createdDate) : null,
        sampleProductOrderNumber: item.sampleProductOrderNumber,
        cost: item.cost,
        createdDateUIString: item.createdDate ? formatDate(new Date(item.createdDate), 'MM/dd/yyyy', 'en-US') : '',
        contact: item.firstName + ' ' + item.lastName,
        customer: item.customerNumber + "-" + item.companyName,
      } as ISampleProductOrderHeader))));
  }
  public getSampleProductOrderDetailsByHeader(body: IGetSampleProductOrderDetailsByHeader): Observable<Array<ISampleProductOrderDetails>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_PRODUCT_ORDER_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getAllReorderReport(): Observable<Array<ISampleReorderReport>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_REORDER_REPORT}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getAllSampleUsageReport(body: IGetFilterSampleUsageReport): Observable<Array<ISampleUsageReport>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_USAGE_REPORT}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  
  private orderHeaderGridData: ISampleProductOrderHeader[];
  private orderDetailsGridData: ISampleProductOrderDetails[];
 
  private singleOrderHeaderGridData: ISampleProductOrderHeader;
  private costHeaderGridData: ISampleSubCategoryCost[];
  private reorderHeaderGridData: ISampleReorderReport[];
  private usageHeaderGridData: ISampleUsageReport[];
  public setOrderHeaderGridData(data: ISampleProductOrderHeader[]) {
    this.orderHeaderGridData = data;
  }
  public setOrderDetailsGridData(data: ISampleProductOrderDetails[]) {
    this.orderDetailsGridData = data;
  }
  public setSingleOrderHeaderGridData(data: ISampleProductOrderHeader) {
    this.singleOrderHeaderGridData = data;
  }  
  public getSingleOrderHeaderGridData() {
    return this.singleOrderHeaderGridData;
  }
  public setCostHeaderGridData(data: ISampleSubCategoryCost[]) {
    this.costHeaderGridData = data;
  }
  public setReorderHeaderGridData(data: ISampleReorderReport[]) {
    this.reorderHeaderGridData = data;
  }
  public setUsageHeaderGridData(data: ISampleUsageReport[]) {
    this.usageHeaderGridData = data;
  }
  
  //#region error List
  public getErrorList(): Observable<Array<IErrorList>> {
    const endPoint = `${ConfigService.APIs.endPoints.KAWNEER_ADMIN.GET_ERROR_LIST}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );

  }
  public getSampleAdminBudgetReport(body: IGetFilterSampleBudgetReport): Observable<Array<ISampleAdminBudget>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_ADMIN_BUDGET_REPORT}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getSampleAdminBudgetAllocationReport(): Observable<Array<ISampleAdminBudgetAllocation>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.GET_SAMPLE_ADMIN_BUDGET_ALLOCATION_REPORT}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public AddSampleBudgetAssociation(body: ISampleAdminBudgetAllocation): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.ADD_SAMPLE_ADMIN_BUDGET_ASSOCIATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public DeleteSampleBudgetAssociation(body: ISampleAdminBudgetAllocation): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_SAMPLE_FULFILLMENT_ADMIN.DELETE_SAMPLE_ADMIN_BUDGET_ASSOCIATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
      );
  }
}
